import styled from '@emotion/styled';
import { borderRadii } from 'app/spacing';
import { KizenTypography } from '__app/typography';
import Button from '__components/Button';
import css from '@emotion/css';

export const StyledHeader = styled(KizenTypography)`
  margin-bottom: 20px;
  &:not(:first-of-type) {
    margin-top: 25px;
  }
`;

export const StyledReturnScopeList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const StyledBottomButtons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const StyledAddReturnScopeButton = styled(Button)`
  margin: 0;
  margin-top: 2px;
  padding-left: 0;
`;

export const StyledScopeWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const StyledScopeCard = styled.div<{ hasError: boolean }>`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 15px;
  border: 1px solid
    ${({ hasError }) =>
      hasError
        ? 'var(--color-button-warning-default)'
        : 'var(--color-border-medium)'};
  border-radius: ${borderRadii.small};
`;

export const StyledDiv = styled.div<{ width: number }>`
  ${({ width }) => css`
    width: ${width}px;
  `}
`;
